
import {get,post} from '../libs/ajax.js'

export default {
    //媒介面板-媒体-消耗漏斗
    getCostData: (data, options) => {
        return get('/cost/panel/data', data, options)
    },
    //媒介面板-媒体KPI-各渠道面板左侧数据
    getMediaKPI: (data, options) => {
        return get('/media/kpi_panel', data, options)
    },
    //媒介面板-媒体KPI-各渠道面板右侧数据
    getMediaKPIDetail: (data, options) => {
        return get('/media/kpi_panel_detail', data, options)
    },

    //媒介面板-媒体KPI-媒体大盘
    getMediaMarket: (data, options) => {
        return get('/media/market', data, options)
    },
    //媒介面板-媒体KPI-集团概览
    getMediaGroupOverview: (data, options) => {
        return get('/media/bloc/overview_panel', data, options)
    },
    //媒介面板-媒体KPI-集团流失情况
    getMediaGroupLoss: (data, options) => {
        return get('/media/bloc/loss_panel', data, options)
    },
    //媒介面板-媒体KPI-集团消耗TOP
    getMediaGroupCostTop: (data, options) => {
        return get('/media/bloc/cost_top', data, options)
    },
    //媒介面板-媒体KPI-集团波动TOP
    getMediaGroupFluctuationTop: (data, options) => {
        return get('/media/bloc/cost_fluctuation_top', data, options)
    },
    //媒介面板-媒体KPI-产品概览
    getMediaAppOverview: (data, options) => {
        return get('/media/app/overview_panel', data, options)
    },
    //媒介面板-媒体KPI-集团流失情况
    getMediaAppLoss: (data, options) => {
        return get('/media/app/loss_panel', data, options)
    },
    //媒介面板-媒体KPI-产品消耗TOP
    getMediaAppCostTop: (data, options) => {
        return get('/media/app/cost_top', data, options)
    },
    //媒介面板-媒体KPI-产品波动TOP
    getMediaAppFluctuationTop: (data, options) => {
        return get('/media/app/cost_fluctuation_top', data, options)
    },

    //运营面板-消耗漏斗
    getYYCostData: (data, options) => {
        return get('/cost/yy_panel/data', data, options)
    },
    //运营面板-消耗漏斗-运营团队下拉框
    getYYCostGroupList: (data, options) => {
        return get('/cost/yy_panel/selector', data, options)
    },
    //运营面板-消耗漏斗-运营成员下拉框
    getYYCostGroupUserList: (data, options) => {
        return get('/cost/yy_panel/yy_list', data, options)
    },
    //运营面板-媒体KPI-运营团队下拉框
    getYYMediaGroupList: (data, options) => {
        return get('/media/yy_panel/selector', data, options)
    },
    //运营面板-媒体KPI-各渠道面板左侧数据
    getYYMediaKPI: (data, options) => {
        return get('/media/yy_kpi_panel', data, options)
    },
    //运营面板-媒体KPI-各渠道面板右侧数据
    getYYMediaKPIDetail: (data, options) => {
        return get('/media/yy_kpi_panel_detail', data, options)
    },
    //运营面板-媒体KPI-媒体大盘
    getYYMediaMarket: (data, options) => {
        return get('/media/yy_market', data, options)
    },


    //销售面板-销售团队下拉框
    getXSGroupList: (data, options) => {
        return get('/xs_panel/selector', data, options)
    },
    //销售面板-销售成员下拉框
    getXSGroupUserList: (data, options) => {
        return get('/xs_panel/xs_list', data, options)
    },
    //销售面板-下单漏斗
    getXSCostData: (data, options) => {
        return get('/cost/xs_panel/data', data, options)
    },
    //销售面板-下单KPI
    getXSOrderKPI: (data, options) => {
        return get('/xs_order/kpi_panel', data, options)
    },
    // 销售面板-项目覆盖-筛选框下拉列表
    getXSProjectSearchList: (data, options) => {
        return post('/xs_project/search_list', data, options)
    },
    // 销售面板-项目覆盖-列表
    getXSProjectList: (data, options) => {
        return post('/xs_project/get_list', data, options)
    },


    //客服面板-客服团队下拉框
    getKFGroupList: (data, options) => {
        return get('/kf_panel/selector', data, options)
    },
    //客服面板-客服成员下拉框
    getKFGroupUserList: (data, options) => {
        return get('/kf_panel/kf_list', data, options)
    },
    //客服面板-销售成员下拉框
    getKFXSList: (data, options) => {
        return get('/kf_panel/xs_list', data, options)
    },
    //客服面板-下单漏斗
    getKFCostData: (data, options) => {
        return get('/cost/kf_panel/data', data, options)
    },
    //客服面板-下单KPI
    getKFOrderKPI: (data, options) => {
        return get('/kf_order/kpi_panel', data, options)
    },

      // 创意面板-下拉框数据
      getCYPanelInfo: (data, options) => {
        return get('/cy_panel/info', data, options)
    },
     // 创意面板-创意团队下拉框-创意
     getCYPanelSelector: (data, options) => {
        return get('/cy_panel/selector', data, options)
    },
     // 创意面板-创意成员下拉框-创意
     getCYPanelCylist: (data, options) => {
        return get('/cy_panel/cy_list', data, options)
    },

    // 创意面板-需求总览
    getCYPanelOverview: (data, options) => {
        return get('/cy_panel/overview', data, options)
    },
      // 创意面板-效果-分媒体
      getCYPanelEffect: (data, options) => {
        return get('/cy_panel/effect', data, options)
    },
    // 创意面板-产能-分媒体
    getCYPanelCapacity: (data, options) => {
        return get('/cy_panel/capacity', data, options)
    },

    // 季度消耗-创意组
    getXsQuarterSaleGroup: (data, options) => {
        return post('/xs_quarter/search_list', data, options)
    },
    // 季度消耗-列表
    getXsQuarterList: (data, options) => {
        return post('/xs_quarter/get_list', data, options)
    },

    // 季度新品-搜索
    getXsQuarterProjectGroup: (data, options) => {
        return post('/xs_quarter/project/search_list', data, options)
    },
    // 季度新品-列表
    getXsQuarterProjectList: (data, options) => {
        return post('/xs_quarter/project/get_list', data, options)
    },
}